import {uniqBy} from 'lodash';
// import getFloorplanSize from '../../../util/getFloorplanSize';
// import ReactHtmlParser from 'react-html-parser';

const refactorPage = (data) => {

  const allRanges = data.map(item => {

    const allSeries = data.filter(series => {
      return series.variant === item.variant;
    }).map(series => {
      
      // const allModels = data.filter(series => {
      //   return (series.variant === item.variant) && (series.model === item.model);
      // }).map(model => {
      //   return {
      //     title: model.model,
      //     id: model.model + '_model',
      //   }
      // })

      // const models = uniqBy(allModels, 'title');
      const images = series.images.split(',');
      const image = images[0]
      return {
        title: series.model,
        id: series.model + '_series',
        rangeId: item.variant + '_range',
        rangeTitle: item.variant,
        image
        // models
        
      }
    })

    const series = uniqBy(allSeries, 'title');

    return {
      title: item.variant,
      id: item.variant + '_range',
      models: series
    }
  });

  const ranges = uniqBy(allRanges, 'title');

  return {
    ranges
  }

  // const modelData = get(props, 'data.modelsFloorPlans.nodes', []);

  // const ranges = data.map(range => {

  //   const rangeTitle = get(range, 'title', null);
  //   const rangeId = get(range, 'id', null);
  //   const seriesArr = get(range, 'acf_range.rangeSeriesRef', [])

  //   const series = seriesArr ? seriesArr.map(seriesItem => {
  //     const title = get(seriesItem, 'title', null);
  //     const id = get(seriesItem, 'id', null);
  //     const specsArr = get(seriesItem, 'acf_series.seriesSpecsRep', []);

  //     let seriesModels = [];

  //     modelData.forEach(model => {
  //       if(get(model, 'acf_floor_plan.modelSeries').find(s => s.id === id)) {
  //         seriesModels.push(model);
  //       }
  //     });

  //     let modelItems = []

  //     const specs = specsArr ? specsArr.map(spec => {
  //       const title = get(spec, 'seriesSpecRepTitle', null);

  //       let modelsArr = []
        
  //       seriesModels.forEach(model => {
  //         const seriesSpec = get(model, 'acf_floor_plan.seriesSpec', null)
  //         if(title && seriesSpec && seriesSpec.trim().toLowerCase() === title.trim().toLowerCase()) {
  //           modelsArr.push(model);
  //         }
  //       });
          
  //       const models = modelsArr ? modelsArr.map(model => {
  //         const title = get(model, 'title', null);
  //         const id = get(model, 'id', null);
          
  //         const layoutId = get(model, 'acf_floor_plan.modelLayoutId', null);
  //         const layoutName = get(model, 'acf_floor_plan.modelLayoutName', null);

  //         const size = getFloorplanSize(layoutName);

  //         const modelData = {
  //           title: title ? ReactHtmlParser(title)[0] : null,
  //           id,
  //           layoutId,
  //           layoutName,
  //           size,
  //         }
           
  //         modelItems.push(modelData)

  //         return modelData

  //       }) : null

  //       return {
  //         title: title ? title.trim() : null,
  //         models
  //       }
  //     }): null // .filter(item => item.models && item.models.length > 0) : null;

  //     return {
  //       range: rangeTitle,
  //       rangeId: rangeId,
  //       title,
  //       id,
  //       models: modelItems
  //     }

  //   }).filter(item => item.models && item.models.length > 0): null;

  //   return {
  //     title: rangeTitle,
  //     id: rangeId,
  //     series
  //   }
  // }).filter(item => item.series && item.series.length > 0)

  // return {
  //   ranges
  // }
}

export default refactorPage